var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-board-item",class:{ on: _vm.on },on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"lazy",undefined,$event.key,undefined))return null;return _vm.$emit( 'clickLazy' )},function($event){return _vm.$emit( 'click' )}]}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }